/**
 * EmptyState - T053
 *
 * Placeholder for empty lists/states
 */
import { type ReactNode } from 'react';
import GlassPanel from './GlassPanel';
import Button from './Button';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

const defaultIcon = (
  <svg
    className="w-12 h-12 text-white/20"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1}
      d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
    />
  </svg>
);

export function EmptyState({
  icon = defaultIcon,
  title,
  description,
  action,
}: EmptyStateProps) {
  return (
    <GlassPanel variant="subtle" className="text-center py-12">
      <div className="flex flex-col items-center gap-4">
        {icon}
        <div>
          <h3 className="text-lg font-medium text-white/70">{title}</h3>
          {description && (
            <p className="mt-1 text-sm text-white/40">{description}</p>
          )}
        </div>
        {action && (
          <Button variant="primary" onClick={action.onClick}>
            {action.label}
          </Button>
        )}
      </div>
    </GlassPanel>
  );
}

export default EmptyState;
